import { REDUX_STORE } from '@funnels/constants';
import {
  ClearAuthenticationErrorAction,
  SetAuthenticationErrorAction,
  AuthSuccessAction,
  LogoutAction,
} from '@funnels/types';

export function clearAuthenticationError(): ClearAuthenticationErrorAction {
  return { type: REDUX_STORE.AUTHENTICATION.ACTION_TYPES.CLEAR_AUTHENTICATION_ERROR };
}

export function setAuthenticationError(message: string = 'Unknown error'): SetAuthenticationErrorAction {
  return { type: REDUX_STORE.AUTHENTICATION.ACTION_TYPES.SET_AUTHENTICATION_ERROR, message };
}

export function authSuccess(token: string): AuthSuccessAction {
  return { type: REDUX_STORE.AUTHENTICATION.ACTION_TYPES.AUTH_SUCCESS, token };
}

export function logout(): LogoutAction {
  return { type: REDUX_STORE.AUTHENTICATION.ACTION_TYPES.LOGOUT };
}
